export default __webpack_public_path__ + "static/media/home.9a57e5c5.png";